// Map of skill id → ability id, sourced from data/srd/rules/skills.json so
// edits to the SRD ruleset propagate automatically.
//
// Exposed as a function so consumers (tests, the engine) can ask:
//   skillAbility('athletics') → 'str'
//   listSkills() → [{id, name, ability, description}, ...]

import skillsRules from '../../../data/srd/rules/skills.json';

const SKILLS = skillsRules.items || [];
const SKILL_ABILITY = Object.fromEntries(SKILLS.map((s) => [s.id, s.ability]));
const SKILL_BY_ID = Object.fromEntries(SKILLS.map((s) => [s.id, s]));

export const skillAbility = (skillId) => SKILL_ABILITY[skillId] || null;
export const skillName = (skillId) => SKILL_BY_ID[skillId]?.name || skillId;
export const listSkills = () => SKILLS.slice();
export const isKnownSkill = (skillId) => Object.prototype.hasOwnProperty.call(SKILL_ABILITY, skillId);
